export default "__VITE_ASSET__BTVvzEoj__"